'use client';

import { useContext } from 'react';

import DIContext from './DIContext';

import type { Deps } from '@Contexts/DI';

export default function useDeps(): Deps {
  return useContext(DIContext);
}
